/* eslint-disable no-void */

import * as vp from 'vopay';

import axios from 'axios';
import { useEffect, useState } from 'react';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ClientBankAccountsResponse,
  (requestParams: vp.ClientBankAccountsRequest) => void,
  () => void,
  (requestParams: vp.ClientBankAccountsRequest) => Promise<vp.ClientBankAccountsResponse>,
];

function useFetchClientBankAccounts({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [params, setParams] = useState<vp.ClientBankAccountsRequest>();
  const [response, setResponse] = useState<vp.ClientBankAccountsResponse>({
    ErrorMessage: '',
    Success: false,
    BankAccounts: {},
  });
  const [shouldSendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    const sendRequest = async (requestParams: vp.ClientBankAccountsRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.fetchClientBankAccounts(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.ClientBankAccountsRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setSendRequest(false);
      setParams(undefined);
      setResponse({
        ErrorMessage: '',
        Success: false,
        BankAccounts: {},
      });
    },
    async (requestParams: vp.ClientBankAccountsRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.fetchClientBankAccounts(requestParams, source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchClientBankAccounts);
